<template>
    <input class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border border-gray-300 rounded-md px-4 py-2 w-full"
           :class="[{'bg-white':!disabled,'bg-gray-100':disabled},{'cursor-pointer':!disabled,'cursor-not-allowed':disabled}]" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" ref="input" :disabled="disabled">
</template>

<script>
    export default {
        props: ['modelValue','disabled'],

        emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>

